import React from 'react';
import { Container, Typography, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import './OurApps.scss';

const apps = [
    {
        name: 'LiftLog',
        tagline: 'Your Gym Journal, Reimagined',
        description: 'Track workouts, monitor progress, and hit new personal records. Built for lifters who want results.',
        internalTo: '/liftlog',
        accentColor: '#D4A843',
        status: 'Available',
        previewGradient: 'linear-gradient(135deg, #1a1200 0%, #2d1e00 60%, #1a1000 100%)',
        domain: 'liftlog',
    },
    {
        name: 'RelayR',
        tagline: 'Your Communities, Connected',
        description: 'Join networks, discover communities, and chat in real-time. A modern platform for meaningful conversations.',
        internalTo: '/relayr',
        accentColor: '#6C5CE7',
        status: 'Coming Soon',
        previewGradient: 'linear-gradient(135deg, #0d0a2b 0%, #1a1445 60%, #0d0a2b 100%)',
        domain: 'relayr',
    },
    {
        name: 'The AG League',
        tagline: 'Compete. Rise. Dominate.',
        description: 'A competitive gaming platform empowering amateur players and teams to compete in ladders, leagues, tournaments, and seasonal competitions while building their esports presence.',
        externalUrl: 'https://www.theagleague.com',
        accentColor: '#F0B429',
        status: 'Live',
        previewGradient: 'linear-gradient(135deg, #0f0e1a 0%, #1a1635 60%, #0d1b3e 100%)',
        domain: 'theagleague.com',
    },
    {
        name: 'CodeMetrics',
        tagline: 'Engineering Intelligence, Simplified.',
        description: 'An AI-powered code quality and analytics platform that helps teams identify technical debt, improve maintainability, track performance, and make data-driven engineering decisions.',
        externalUrl: 'https://www.codemetrics.com',
        accentColor: '#3ECFCF',
        status: 'Live',
        previewGradient: 'linear-gradient(135deg, #0d1117 0%, #0e1f2e 60%, #0a1a26 100%)',
        domain: 'codemetrics.com',
    },
    {
        name: 'Evolve Pulse',
        tagline: 'Your Analytics, Evolved.',
        description: 'A modern SaaS platform delivering real-time insights and intelligent dashboards so your team can move faster, stay aligned, and make smarter decisions.',
        externalUrl: 'https://www.useevolvepulse.com',
        accentColor: '#EF002F',
        status: 'Live',
        previewGradient: 'linear-gradient(135deg, #150008 0%, #250010 60%, #1a000c 100%)',
        domain: 'useevolvepulse.com',
    },
];

const BrowserPreview = ({ app }) => (
    <div className="app-browser-preview" style={{ background: app.previewGradient }}>
        <div className="browser-chrome">
            <div className="browser-dots">
                <span style={{ background: '#ff5f57' }} />
                <span style={{ background: '#febc2e' }} />
                <span style={{ background: '#28c840' }} />
            </div>
            <div className="browser-url">{app.domain}</div>
        </div>
        <div className="browser-body">
            <span className="browser-logo" style={{ color: app.accentColor }}>
                {app.name}
            </span>
            <span className="browser-badge" style={{ borderColor: `${app.accentColor}55`, color: app.accentColor }}>
                {app.externalUrl ? 'Visit Site →' : 'Learn More →'}
            </span>
        </div>
    </div>
);

const AppCard = ({ app }) => {
    const inner = (
        <div className="app-card" style={{ '--app-accent': app.accentColor }}>
            <BrowserPreview app={app} />
            <div className="app-card-info">
                <div className="app-card-header">
                    <Typography variant="h6" className="app-name">
                        {app.name}
                    </Typography>
                    <span className="app-status" data-live={app.status === 'Live'}>
                        {app.status}
                    </span>
                </div>
                <Typography className="app-tagline">{app.tagline}</Typography>
                <Typography className="app-description">{app.description}</Typography>
                <span className="app-cta">
                    {app.externalUrl ? `Visit ${app.domain} →` : 'Learn more →'}
                </span>
            </div>
        </div>
    );

    if (app.internalTo) {
        return <Link to={app.internalTo} className="app-card-link">{inner}</Link>;
    }
    return (
        <a href={app.externalUrl} target="_blank" rel="noopener noreferrer" className="app-card-link">
            {inner}
        </a>
    );
};

const OurApps = () => (
    <section className="our-apps-section" id="apps">
        <Container maxWidth="lg">
            <Typography variant="overline" className="our-apps-label">
                Our Products
            </Typography>
            <Typography variant="h5" className="our-apps-title">
                Apps We've Built
            </Typography>
            <Typography className="our-apps-sub">
                Real products, live in the world — each one designed to solve a genuine problem with clean, modern software.
            </Typography>

            <Grid container spacing={3} className="our-apps-grid">
                {apps.map((app, i) => (
                    <Grid item xs={12} sm={6} md={4} key={i}>
                        <AppCard app={app} />
                    </Grid>
                ))}
            </Grid>
        </Container>
    </section>
);

export default OurApps;
